// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mall-left[data-v-349af3cc]{text-align:center;line-height:2.083333rem;background:#fff}.mall-left .item[data-v-349af3cc]{cursor:pointer;width:9.583333rem}.mall-left .item.active[data-v-349af3cc]{color:#096aff}", ""]);
// Exports
module.exports = exports;
